import {dt, t, getLocale, getLangPrefix} from 'l10n';
import React, { useState } from 'react';
import {withRouter} from "react-router";
import {Helmet} from 'react-helmet';
import PropTypes from 'prop-types';

import paths from 'paths';
import Registry from 'registry';
import isEmpty from 'lodash/isEmpty';

import './header.scss';
import ModalUploadFilm from '../modals/ModalUploadFilm';
import ModalAddWallPost from '../modals/ModalAddWallPost';
import ModalAddWardrobePost from '../modals/ModalAddWardrobePost';
import {Link} from 'components/ReactRouterDomLocalized';

const Header = ({ order, changeOrder, videos, materials, match, history, kind }) => {
    const locale = getLocale();
    const [showModal, setShowModal] = useState(false);
    
    if (materials.tag) {
        if (locale === "en" && (materials.tag.slug_en !== match.params.slug) && !isEmpty(match.params.slug)) {
            history.push(getLangPrefix() + paths.amateurFilms.toPath({slug: materials.tag.slug_en}));
        }

        if (locale === "fr" && (materials.tag.slug !== match.params.slug) && !isEmpty(match.params.slug)) {
            history.push(paths.amateurFilms.toPath({slug: materials.tag.slug}));
        }
    }

    let title = '';
    let titleTag = '';
    let heading = '';
    let addButtonTitle = '';
    let BOBSTORE_URL = Registry.get('BOBSTORE_URL');

    switch (kind) {
        case 'wall':
            title = 'The wall  of BobTV, photos and videos posted by members';
            heading = 'The Wall';
            addButtonTitle = 'New post';
            break;
        case 'videos':
            title = 'Amateur videos of bobbesies and bobbers';
            titleTag = "Les vidéos d'exhibe de BobTV | %1 |";
            heading = 'Amateur videos of bobbesies and bobbers';
            addButtonTitle = 'Publish your video';
            break;
        case 'wardrobe':
            title = 'Bobstore wardrobe';
            heading = 'Bobstore wardrobe';
            addButtonTitle = 'Add your photo';
            break;
    }

    return(
        <header className='materials-header ui-kit-base'>
            {materials.tag &&
                <Helmet>
                    <title>
                        {dt('meta', titleTag ? titleTag : title, materials.tag.name)}
                    </title>
                </Helmet>
            }
            <div className='content'>
                <h1 className='ui-header'>{t(heading)}</h1>
                {kind === 'wall' &&
                    <div className='text-header'>
                        <p>
                            {t('Post a photo or a video to the Wall here or from your profile page.')}<br/>
                            {t('Your post will be shown immediately on this page and at BobTV chatrooms.')}
                        </p>
                    </div>
                }
                {kind === 'videos' &&
                    <div className='tags'>
                        {!materials.tag && materials.tags.map((tag, idx) =>
                            <Link to={paths.amateurFilms.toPath({slug: locale === "en" ? tag.slug_en : tag.slug})} key={idx} className='tag'>
                                {locale === "en" ? tag.name_en : tag.name}
                            </Link>
                        )}
                        {materials.tag &&
                        <div className='selected-tag'>
                            <span className='label'>
                                {t('Selected tag:')}
                            </span>
                            <div className='tag'>
                                <span className='tag-name ui-mini'>
                                    {locale === "en" ? materials.tag.name_en : materials.tag.name}
                                </span>
                                <Link className='close' to={paths.amateurFilms.toPath()}>&times;</Link>
                            </div>
                        </div>
                        }
                    </div>
                }
                {kind === 'wardrobe' &&
                    <div className='text-header'>
                        <p>
                            Vous venez de recevoir un cadeau de la boutique Bobstore ! Commencez les essayages et partagez vos photos sur le dressing de BobTV.<br/>
                            Soyez les mannequins de charme de Bobstore pour notre plus grand plaisir.
                            
                        </p>
                    </div>
                }
                <div className='button-container'>
                    <div className='sort-header'>
                        <p>{t('Sort by:')}</p>
                        <div className='ui-selector'>
                            <div
                                onClick={() => changeOrder('date')}
                                className={order === 'date' ? 'active' : ''}
                            >
                                {t('date')}
                            </div>
                            <div
                                onClick={() => changeOrder(videos ? 'views' : 'popularity')}
                                className={(order === 'popularity' || order === 'views') ? 'active' : ''}
                            >
                                {t('popularity')}
                            </div>
                        </div>
                    </div>
                    {kind == 'videos' &&
                        <ModalUploadFilm show={showModal} closeFn={() => setShowModal(false)} />}
                    {kind == 'wall' &&
                        <ModalAddWallPost show={showModal} closeFn={() => setShowModal(false)} />}
                    {kind == 'wardrobe' &&
                        <ModalAddWardrobePost show={showModal} closeFn={() => setShowModal(false)} />}

                    
                        <div
                            className='ui-button primary upload-button'
                            onClick={() => {
                                if (!showModal) {
                                    setShowModal(true)
                                } else {
                                    setShowModal(false)
                                    setTimeout(() => setShowModal(true), 100)
                                }
                            }}
                        >
                            {t(addButtonTitle)}
                        </div>
                      
                </div>
            </div>
        </header>
    )
};

Header.propTypes = {
    kind: PropTypes.string.isRequired,
    videos: PropTypes.bool.isRequired,
    order: PropTypes.string.isRequired,
    changeOrder: PropTypes.func.isRequired,
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/materialList/header.js